<template>
  <v-container fill-height>
    <v-row v-if="$store.state.auth.isAuthenticated">
      <v-col cols="6" offset="3">
        <v-form ref="form" @keypress.native.stop>
          <v-row>
            <v-col class="text-center">
              <v-text-field ref="codID" label="Enter Certificate of Destruction ID" v-model="submitcodID" 
                single-line autofocus />
                <v-btn @click="submit">Submit</v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
        <v-progress-linear v-if="loading" indeterminate></v-progress-linear>
        <v-row>
          <v-col v-if="codInfo && codInfo.length > 0" class="text-center">
            <v-card-text>Certificate{{this.codInfo.length > 1 ? "s" : ""}} found with identifier {{this.codID}}:</v-card-text>
            <v-row v-for="cod in codInfo" :key="cod.serial_number" >
              <v-col cols="8" offset="2">
                <v-card>
                  <div class="green darken-4" style="padding:10px;">
                  <div class="white" style="padding:5px;">
                  <div class="green darken-4" style="padding:2px;">
                  <div class="white" style="padding:20px;">
                    <div class="white" style="border-style:solid; border-color:#1B5E20 !important">
                      <v-card-text style="font-size:40px; font-weight:bold;">Certificate of Data Destruction</v-card-text>
                      <v-card-text style="font-size:20px; font-weight:bold; padding-bottom:0px;">Certificate ID :</v-card-text>
                      <v-card-text style="font-size:20px; font-weight:bold; text-decoration: underline;">{{cod.cert_num}}</v-card-text>
                      <v-card-text style="font-size:20px; padding-bottom:0px;">This document certifies that the following electronic equipment was received for data destruction from </v-card-text>
                      <v-card-text style="font-size:20px; font-weight:bold;">{{cod.branch_name}}</v-card-text>
                      <v-row v-if="cod.asset_tag">
                        <v-card-text>Asset Tag : {{cod.asset_tag}}</v-card-text>
                      </v-row>
                      <v-row dense>
                        <v-col cols="4"  offset="2">
                          <v-card-text>Drive S/N :<br>{{cod.serial_number}}</v-card-text>
                          <v-card-text>Drive Model :<br>{{cod.model}}</v-card-text>
                          <v-card-text v-if="cod.comp_sn">Computer S/N :<br>{{cod.comp_sn}}</v-card-text>
                        </v-col>
                        <v-col cols="4">
                          <v-card-text>Destruction Date :<br>{{cod.timestamp | moment("MM-DD-YYYY HH:MM:SS")}}</v-card-text>
                          <v-card-text>Destruction Result :<br>{{cod.result == 1 ? "Pass" : "Fail"}}</v-card-text>
                          <v-card-text>Verified By :<br>{{cod.user.toUpperCase()}}</v-card-text>
                          <v-card-text>{{$route.meta.authenticated}}</v-card-text>
                        </v-col>
                      </v-row>
                    </div>
                    </div>
                    </div>
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col v-else class="text-center">
            No certificate found with identifier {{this.codID}}.
          </v-col>
        </v-row>
  </v-container>
</template>
<script>
import moment from "moment";
import axios from "axios";
import config from "../config";

export default {
  name: 'COD',
  data: function() {
    return {
    loading: false,
    submitcodID: null,
    codID: null,
    codInfo: []
    }
  },
  methods: {
    clear()
		{
      this.submitcodID = null
		}
    ,submit()
		{
      this.codID = this.submitcodID
      this.$router.push({ name: 'cod', params: { id: this.submitcodID}})
      this.getCOD(this.codID)
		}
    ,async getCOD(key) {
      this.loading = true
      this.codInfo = []
      try
      {
        let response = await axios.get(config.QDS + "hdd/cod/" + key, {headers: { Authorization: this.$store.state.auth.idToken }})
        if(response.data && response.data.length)
        {
          this.codInfo = response.data
        }
      }
      catch (error)
      {
        console.error(JSON.stringify(error))
      }
      finally
      {
        this.loading = false
      }
    }
  },
  mounted()
  {
    if (this.$route.params.id && this.$route.params.id.length > 0)
    {
      this.codID = this.$route.params.id
      this.getCOD(this.codID)
    }
  }
};
</script>
